import React from 'react'


export const SessionContext = React.createContext({
    unidad: null,
    permisos: null
});

